import React from "react";
import { Navigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import useCheckPermission from "../hooks/useCheckPermission";

const ProtectedRoute = ({ serviceIds = null, permission = null, module = null, modules = null, children, adminOnly = false }) => {
  const { user } = useSelector((state) => state.auth);
  const { can, hasModule, hasAnyModule } = useCheckPermission();
  const serviceId = user?.service?.id;
  const userRole = user?.role?.[0]?.name;
  const isAdmin = userRole === 'Admin' || userRole === 'admin';

  if (serviceIds && !serviceIds.includes(serviceId)) {
    toast.error('You do not have access to this module.');
    return <Navigate to="/dashboard" replace />;
  }

  if (adminOnly && !isAdmin) {
    toast.error('You do not have permission to access this page.');
    return <Navigate to="/dashboard" replace />;
  }

  if (permission) {
    const [module, action] = permission.split('.');
    if (!can(module, action)) {
      console.warn(`Access denied: Missing permission ${permission}`);
      toast.error('You do not have permission to access this page.');
      return <Navigate to="/dashboard" replace />;
    }
  }
  if (module) {
    if (!hasModule(module)) {
      console.warn(`Access denied: Missing module ${module}`);
      toast.error('You do not have permission to access this page.');
      return <Navigate to="/dashboard" replace />;
    }
  }
  if (modules) {
    if (!hasAnyModule(modules)) {
      console.warn(`Access denied: Missing modules ${modules}`);
      toast.error('You do not have permission to access this page.');
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
